<template>
  <div>
    <v-container fluid>
      <v-card elevation="0">
        <v-card-title class="secondary--text font-weight-medium pt-5">
          <v-row align="center" no-gutters class="">
            <v-col cols="12">
              <h3 class="my-2 primary--text">
                {{ $t("plans.plans") }}
              </h3>
            </v-col>
            <v-col cols="3">
              <v-text-field
                :label="$t('common.search')"
                v-model="search"
                :placeholder="$t('plans.name')"
                class="custom-label-color"
                hide-details="auto"
                outlined
                dense
              >
              </v-text-field>
            </v-col>
            <v-col cols="9" class="text-end">
              <v-btn
                class="ml-2 white--text"
                color="primary"
                @click="openRightSideDrawer"
              >
                <v-icon class="mr-1"> mdi-plus-circle </v-icon>
                <span>{{ $t("plans.addNew") }}</span>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>

        <!-- <div id="wrapper2">
          <div id="top-scroll" class="width-scroll-top"></div>
        </div> -->
        <v-data-table
          :footer-props="{ 'items-per-page-options': [50, 100, 150, 200, -1] }"
          class="mt-1 datatable mb-9 table-reference-for-scroll"
          id="landlordPlanTable"
          :headers="headers"
          :items="landlordPlanLists"
          :hide-default-footer="footer"
          :search="search"
          :loading="loading"
          mobile-breakpoint="0"
          :options.sync="options"
          :server-items-length="totallandlordPlans"
        >
          <template v-slot:[`item._id`]="{ item }">
            <p class="my-0 py-0">
              {{
                options.page * options.itemsPerPage -
                  options.itemsPerPage +
                  landlordPlanLists
                    .map(function(x) {
                      return x._id;
                    })
                    .indexOf(item._id) +
                  1
              }}
            </p>
          </template>

          <template v-slot:[`item.planName`]="{ item }">
            <span v-if="item.planName">
              {{ item.planName }}
            </span>
            <span v-else> -- </span>
          </template>

          <template v-slot:[`item.validity`]="{ item }">
            <span v-if="item.validity">
              {{ item.validity }}
            </span>
            <span v-else> 0 </span>
          </template>

          <template v-slot:[`item.numberOfUsers`]="{ item }">
            <span v-if="item.numberOfUsers">
              {{ item.numberOfUsers }}
            </span>
            <span v-else> 0 </span>
          </template>

          <template v-slot:[`item.numberOfProperties`]="{ item }">
            <span v-if="item.numberOfProperties">
              {{ item.numberOfProperties }}
            </span>
            <span v-else> 0 </span>
          </template>

          <template v-slot:[`item.numberOfUnits`]="{ item }">
            <span v-if="item.numberOfUnits">
              {{ item.numberOfUnits }}
            </span>
            <span v-else> 0 </span>
          </template>

          <!-- <template v-slot:[`item.currency`]="{ item }">
            <span v-if="item.currency">
              {{ item.currency }}
            </span>
            <span v-else> -- </span>
          </template> -->

          <template v-slot:[`item.price`]="{ item }">
            <span v-if="item.price">
              {{ item.price }}
            </span>
            <span v-else> 0 </span>
          </template>

          <template v-slot:[`item.actions`]="{ item }">
            <v-row justify="center" class="mx-auto">
              <v-icon color="primary" @click="editLandlordPlan(item)"
                >mdi-pencil</v-icon
              >
              <!-- <v-icon color="red" @click="showDeleteDialog(item)"
                >mdi-delete</v-icon
              > -->
            </v-row>
          </template>
          <template v-slot:[`item.isActive`]="{ item }">
            <v-row justify="center" class="mx-auto">
              <v-switch
                @click="showToggleDialog(item)"
                v-if="!footer"
                hide-details="auto"
                class="mt-0"
                value
                v-model="item.isActive"
                color="primary"
              ></v-switch>
              <span v-else>{{ item.isActive ? "true" : "false" }}</span>
            </v-row>
          </template>
        </v-data-table>
      </v-card>
      <side-drawer>
        <template slot="formDetails">
          <plan-form />
        </template>
      </side-drawer>
    </v-container>
  </div>
</template>

<script>
// import AddButton from "../../core/components/AddButton.vue";
// import { deleteLandlord } from "../methods/delete_landlord";
import { formatDate } from "@/core/methods/formatDate";
import moment from "moment";
import { toggleLandlordPlan } from "../methods/toggle_landlord_plan";
export default {
  data() {
    return {
      loading: false,
      footer: false,
      search: "",
      variables: {
        limit: 10,
        skip: 0
      },
      options: {
        itemsPerPage: 50,
        page: 1
      },
      landlordPlanLists: [],
      totallandlordPlans: 10
    };
  },
  components: {
    // "add-button": AddButton,
    "side-drawer": () => import("@/core/components/SideDrawer"),
    "plan-form": () => import("@/plans/components/rightSideDrawer/PlanForm.vue")
  },
  computed: {
    paymentTypeText() {
      return {
        PAY_ONLINE: "Pay Online",
        PAY_AT_PROPERTY: "Pay at Property"
      };
    },
    headers() {
      return [
        {
          text: "#",
          align: "left",
          value: "_id",
          width: 10
        },
        {
          text: this.$t("plans.name"),
          align: "left",
          value: "planName",
          width: 150
        },
        {
          text: this.$t("plans.validity"),
          align: "left",
          value: "validity",
          width: 150
        },
        {
          text: this.$t("plans.numberOfUsers"),
          align: "center",
          value: "numberOfUsers",
          width: 150
        },
        {
          text: this.$t("plans.numberOfProperties"),
          align: "left",
          value: "numberOfProperties",
          width: 150
        },
        {
          text: this.$t("plans.numberOfUnits"),
          align: "left",
          value: "numberOfUnits",
          width: 150
        },
        // {
        //   text: this.$t("plans.currency"),
        //   align: "left",
        //   value: "currency",
        //   width: 150
        // },
        {
          text: this.$t("plans.price"),
          align: "left",
          value: "price",
          width: 100
        },

        {
          text: this.$t("landlord.isActive"),
          align: "left",
          value: "isActive",
          width: 100
        },

        {
          text: this.$t("common.actions"),
          value: "actions",
          align: "left",
          width: 100
        }
      ].map(header => {
        header.align = "center";
        header.sortable = false;
        return header;
      });
    }
  },
  watch: {
    search(val) {
      this.loading = true;
      this.$apollo.queries.getAllLandlordValidityPlan.refetch({
        input: {
          limit:
            this.options.itemsPerPage !== -1
              ? this.options.itemsPerPage
              : this.totallandlordPlans,
          skip:
            this.options.page * this.options.itemsPerPage -
            this.options.itemsPerPage
        },
        filter: {
          searchKey: val,
          sortDesc: false,
          sortBy: ""
        }
      });
      this.loading = false;
    },
    options(val) {
      let sortBy = "";
      switch (val.sortBy[0]) {
        case "name":
          sortBy = "firstName";
          break;
        case "user.active":
          sortBy = "active";
          break;
        case "commission":
          sortBy = "commission";
      }
      this.$apollo.queries.getAllLandlordValidityPlan.refetch({
        input: {
          limit:
            this.options.itemsPerPage !== -1
              ? this.options.itemsPerPage
              : this.totallandlordPlans,
          skip:
            this.options.page * this.options.itemsPerPage -
            this.options.itemsPerPage
        },
        filter: {
          searchKey: this.search,
          sortBy: sortBy,
          sortDesc: val.sortDesc[0]
        }
      });
    }
  },
  apollo: {
    getAllLandlordValidityPlan() {
      this.loading = true;
      return {
        query: require("@/plans/api/queries/get_all_landlord_plans.graphql"),
        variables: {
          input: {
            limit: 50,
            skip: 0
          },
          filter: {
            searchKey: this.search,
            sortBy: "",
            sortDesc: false
          }
        },
        result({ data, loading }) {
          // , networkStatus, refetch
          this.landlordPlanLists = this.$format.cloneVariable(
            data.getAllLandlordValidityPlan.landlordValidityPlans
          );
          this.loading = loading;
          this.totallandlordPlans = data.getAllLandlordValidityPlan.totalCount;
        }
      };
    }
  },
  mounted() {
    this.$root.$on("toggleItems", data => {
      if (data.module === "plans") {
        toggleLandlordPlan({
          id: data.item._id,
          status: data.item.isActive
        }).then(({ data }) => {
          if (data.toggleLandlordValidityPlan) {
            this.$store.commit("TOGGLE_BTN_LOADING", false);
            this.$root.$emit("snackbar", {
              snackbar: true,
              text: "Plan Status Changed Successfully",
              color: "green"
            });
            this.$root.$emit("refetchLandlordPlan");
          }
        });
      }
    });
    this.$root.$on("landlordPlanTable", () => {
      this.options.itemsPerPage = 50;
      this.$set(this.options, this.options.itemsPerPage, 50);
    });
    this.$root.$on("refetchLandlordPlan", () => {
      this.$apollo.queries.getAllLandlordValidityPlan.refetch({
        input: {
          limit:
            this.options.itemsPerPage !== -1
              ? this.options.itemsPerPage
              : this.totallandlordPlans,
          skip:
            this.options.page * this.options.itemsPerPage -
            this.options.itemsPerPage
        },
        filter: {
          searchKey: this.search,
          sortDesc: false,
          sortBy: ""
        }
      });
    });
  },
  methods: {
    editLandlordPlan(item) {
      this.$store.commit("EDIT_LANDLORD_PLAN", item);
      this.$store.commit("IS_EDIT_LANDLORD_PLAN", true);
      this.$store.commit("SHOW_RIGHTSIDE_DRAWER", true);
    },
    dateFormat(date) {
      const rawDate = new Date(parseInt(date));
      return moment(rawDate, "YYYY-MM-DD").format("DD-MM-YYYY");
    },

    openRightSideDrawer() {
      this.$store.commit("IS_EDIT_LANDLORD_PLAN", false);

      this.$store.commit("SHOW_RIGHTSIDE_DRAWER", true);
    },
    // showToggleDialog(item) {
    //   this.$root.$emit("toggleDialog", {
    //     dialog: true,
    //     item: item,
    //     module: "plans"
    //   });
    //   this.$root.$emit("refetchLandlordPlan");
    // },

    async showToggleDialog(item) {
      const originalStatus = item.isActive;

      try {
        item.isActive = !originalStatus;

        const { data } = await toggleLandlordPlan({
          id: item._id,
          status: !item.isActive
        });

        if (data.toggleLandlordValidityPlan) {
          this.$root.$emit("snackbar", {
            snackbar: true,
            text: "Plan Status Changed Successfully",
            color: "green"
          });
          this.$root.$emit("refetchLandlordPlan");
        }
      } catch (error) {
        item.isActive = originalStatus;
        console.error("Failed to change status:", error);
      }
    },

    formatDate: formatDate
  },
  beforeDestroy() {
    this.$root.$off("landlordPlanTable");
    this.$root.$off("deleteItems");
    this.$root.$off("refetchLandlordPlan");
    this.$root.$off("toggleItems");
  }
};
</script>
<style scoped>
.datatable >>> .v-data-footer__select {
  direction: ltr !important;
}
.datatable >>> .v-data-footer__pagination {
  direction: ltr !important;
}

/* This is the size of the path of the scrollbar */
#wrapper2 {
  width: 100%;
  overflow-x: scroll;
  overflow-y: hidden;
}

/* This div allow to make the scroll function and show the scrollbar */
#top-scroll {
  height: 1px;
  overflow: scroll;
}

/* This is the size of the scrollbar */
.width-scroll-top {
  width: 2800px;
}
</style>
